// Anoniminis matavimas. Renkam TIK atsitiktinį sesijos ID iš localStorage —
// jokių asmens duomenų, jokių slapukų, sutikimo lango nereikia.
//
// Lentelė `ivykiai` Supabase: RLS leidžia naršyklei tik RAŠYTI, ne skaityti.
// Statistiką skaito tik Claude per Supabase konektorių.
//
// Tipai: atidare | sukimas | kitas | navigacija | vieta_atidaryta

import { supabase } from './supabaseClient'

const RAKTAS = 'klajok_sesija'

function sesijosId() {
  try {
    let id = localStorage.getItem(RAKTAS)
    if (!id) {
      id = (crypto.randomUUID && crypto.randomUUID()) ||
        String(Date.now()) + Math.random().toString(36).slice(2)
      localStorage.setItem(RAKTAS, id)
    }
    return id
  } catch {
    return 'be-sesijos'
  }
}

// Matavimas NIEKADA neturi sulaužyti programėlės ar jos stabdyti.
// Todėl be await, su tyliu klaidų gaudymu.
export function ivykis(tipas, vietaId = null, meta = null) {
  try {
    supabase
      .from('ivykiai')
      .insert({ tipas, vieta_id: vietaId ?? null, sesija: sesijosId(), meta })
      .then(() => {}, () => {})
  } catch {
    // tyla — analitikos gedimas neturi būti matomas vartotojui
  }
}
